import {
  TicketTypesRequest,
  GetTicketTypeRequest,
  CreateTicketTypeRequest,
  UpdateTicketTypeRequest,
  DeleteTicketTypeRequest,
} from '../api/requests';
import type { UserStore } from '~/authentication/stores/user';
import type ApiClient from '~/common/services/ApiClient';
import type { RequestPagination } from '~/common/types';
import type { TicketType, TicketTypeID } from '../types';

export class TicketTypesService {
  apiClient: ApiClient;
  userStore: UserStore;

  constructor(apiClient: ApiClient, userStore: UserStore) {
    this.apiClient = apiClient;
    this.userStore = userStore;
  }

  async fetch(pagination: RequestPagination, params: Record<string, any>) {
    const accessToken = this.userStore.accessToken;
    const request = new TicketTypesRequest({
      token: accessToken,
      params: { ...pagination, ...params },
    });

    return this.apiClient.request(request);
  }

  async get(id: TicketTypeID, params: Record<string, any> = {}) {
    const accessToken = this.userStore.accessToken;
    const request = new GetTicketTypeRequest({
      token: accessToken,
      id,
      params: { ...params },
    });

    return this.apiClient.request(request);
  }

  async create(ticketType: TicketType) {
    const accessToken = this.userStore.accessToken;
    const request = new CreateTicketTypeRequest({
      token: accessToken,
      ticketType,
    });

    return this.apiClient.request(request);
  }

  async update(ticketType: TicketType) {
    const accessToken = this.userStore.accessToken;
    const request = new UpdateTicketTypeRequest({
      token: accessToken,
      ticketType,
    });

    return this.apiClient.request(request);
  }

  async delete(id: TicketTypeID) {
    const accessToken = this.userStore.accessToken;
    const request = new DeleteTicketTypeRequest({
      token: accessToken,
      id,
    });

    return this.apiClient.request(request);
  }
}
